var Category = function() {
  var init = function () {
    $('.category__toggle').off().on('click', function(e){
        e.preventDefault();
        var list = $(this).next('.category');
        $(list).toggleClass('category--open');
        $(this).toggleClass('category__toggle--open');
    });
  }

  init();
}
